import {
  Build,
  Checkmark,
  ClearbitServices,
  Go,
  Sparkles,
} from '@clearkit/icons';
import { CKBox } from 'clearkit';

import styles from './styles';

const appNames = {
  x: 'x',
  clearbit: 'clearbit',
  tools: 'tools',
};

const APPS = [
  {
    name: appNames.x,
    title: 'Clearbit Platform',
    text: 'app.clearbit.com',
    link: '#',
    current: true,
  },
  {
    name: appNames.clearbit,
    title: 'Usage and APIs',
    text: 'dashboard.clearbit.com',
    link: 'https://dashboard.clearbit.com/',
    current: false,
  },
  {
    name: appNames.tools,
    title: 'Free Tools',
    text: 'grow.clearbit.com',
    link: 'https://grow.clearbit.com/',
    current: false,
  },
];

const Icon = ({ appName, className, ...props }) => {
  switch (appName) {
    case appNames.x:
      return <ClearbitServices className={className} {...props} />;
    case appNames.clearbit:
      return (
        <CKBox className="flex items-center justify-center text-gray-600 gradient-ice bg-gradient-to-br w-[36px] h-[36px] mr-[10px]">
          <Build {...props} />
        </CKBox>
      );
    case appNames.tools:
      return (
        <CKBox className="flex items-center justify-center text-gray-600 gradient-ice bg-gradient-to-br w-[36px] h-[36px] mr-[10px]">
          <Sparkles {...props} />
        </CKBox>
      );
  }
};

const AppLink = ({ app, classes }) => (
  <div className={classnames(classes.app, 'rounded-md')}>
    <div className={classes.appDetailContainer}>
      <Icon appName={app.name} className={classes.appIcon} />
      <div className={classes.appDetail}>
        <span className={classes.appTitle}>{app.title}</span>
        <span className={classes.appLinkText}>{app.text}</span>
      </div>
    </div>
    {app.current ? <Checkmark /> : <Go className={classes.arrow} />}
  </div>
);

const AppSwitch = ({ classes }) => {
  return (
    <div className={classes.section}>
      <div className={classes.appContainer}>
        {APPS.map((app) => {
          return app.current ? (
            <AppLink app={app} classes={classes} key={app.name} />
          ) : (
            <a href={app.link} key={app.name}>
              <AppLink app={app} classes={classes} key={app.name} />
            </a>
          );
        })}
      </div>
    </div>
  );
};

AppSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppSwitch);
